<template>
  <template v-if="(type === 'off-shelf' || type === 'sold') && !wework">
    <off-shelf-placeholder />
  </template>
  <template v-else>
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </template>
</template>

<script>
import {mapState} from 'pinia'
import {mapGetters} from 'vuex'
import offShelfPlaceholder from '@components/off-shelf-placeholder.vue'
import {useApplicationStore} from '@stores/application.store'

export default {
  name: 'StandardHolder',

  components: {
    offShelfPlaceholder,
  },

  computed: {
    ...mapState(useApplicationStore, [
      'wework',
    ]),

    ...mapGetters('Car', [
      'typeByCarId',
    ]),

    // carId
    carId () {
      return this.$route.params.id
    },

    // type
    type () {
      return this.typeByCarId(this.carId)
    },
  },
}
</script>

<style lang="scss" scoped></style>

